
import { RoleInclusaoDTO } from '../shared/dto/roleInclusaoDTO';
import createAxiosInstance from './axiosConfig';

const { REACT_APP_ESTEIRA_BACK } = process.env;

const axiosInstance = createAxiosInstance(REACT_APP_ESTEIRA_BACK + '/rest/roleController');

export default class RoleService {
  axios: any;

  constructor() {
    this.axios = axiosInstance;
  }

  async salvarRole(roleData: RoleInclusaoDTO) {
    return await this.axios.post(`/incluirAlterarRole`, roleData);
  };

  async listarRoles() {
    return await this.axios.get(`/listarPerfisHierarquicos`);
  }

  async ativarInativarRole(id: any) {
    return await this.axios.put(`/ativar-inativar/${id}`);
  }
  
  async listarRolesPaginado(page: number, size: number, filtro: RoleInclusaoDTO) {
    return await this.axios.post(`/listar-paginado`, filtro, {
      params: { page, size }
    });
  }

  async buscarRolePorId(id: any) {
    return await this.axios.get(`/buscar-por-id/${id}`);
  }

  async listarRolesRestritas(tipo: string) {
    return await this.axios.get(`/listarRolesRestritas?tipo=${tipo}`);
  }

}